import React from 'react'

const SkeletonCard = () => (
  <div className="ksr-card skeleton-card mb-4">
    <div className="ksr-card-img-wrap">
      <div className="ksr-skeleton-img"></div>
    </div>
    <div className="ksr-card-content">
      <div className="ksr-skeleton-title"></div>
      <div className="ksr-skeleton-subtitle"></div>
      <div className="ksr-skeleton-tags">
        <div className="ksr-skeleton-tag"></div>
        <div className="ksr-skeleton-dot"></div>
        <div className="ksr-skeleton-tag"></div>
      </div>
      <div className="ksr-card-info-row">
        <div className="ksr-info-block">
          <div className="ksr-skeleton-label"></div>
          <div className="ksr-skeleton-value"></div>
        </div>
        <div className="ksr-info-block">
          <div className="ksr-skeleton-label"></div>
          <div className="ksr-skeleton-value"></div>
        </div>
        <div className="ksr-info-block">
          <div className="ksr-skeleton-label"></div>
          <div className="ksr-skeleton-value"></div>
        </div>
      </div>
    </div>
    <div className="ksr-card-side-info">
      <div className="ksr-skeleton-side-label"></div>
      <div className="ksr-skeleton-side-value"></div>
      <div className="ksr-skeleton-side-label"></div>
      <div className="ksr-skeleton-side-value"></div>
      <div className="ksr-skeleton-side-label"></div>
      <div className="ksr-skeleton-side-value"></div>
    </div>
  </div>
)

export default SkeletonCard 